import {createContext} from 'react'
//context for storing values
export const dataContext = createContext(null);